import { CountryCode, isPossiblePhoneNumber, parsePhoneNumber } from "libphonenumber-js";

export const defaultCountry: CountryCode = "BE";
export const allowedCountries: CountryCode[] = ["BE", "FR", "LU", "DE", "GB", "NL"];
export const phoneFormatter = (phoneNumber) => {
    if (!phoneNumber) return phoneNumber;
    const cleanNumber = phoneNumber.replace(/^\++/g, "+");
    if (!isPossiblePhoneNumber(cleanNumber, defaultCountry)) return cleanNumber;
    const number = parsePhoneNumber(cleanNumber, defaultCountry);
    return number.formatInternational();
};
